'use client'

import { CheckboxIcon, GlobeIcon } from '@/_assets/icon-components'
import DetailButton from '@/_components/DetailButton'
import BottomSheet from '@/_components/Sheet'
import { useCustomLocale } from '@/_hooks/useCustomLocale'
import { IRedux } from '@/_store/types'
import { getFilteredLanguages } from '@/_utils/Language'
import { RadioCardItem, RadioCardRoot } from '@/components/ui/radio-card'
import { usePathname, useRouter } from '@/i18n/navigation'
import {
  Box,
  Flex,
  HStack,
  Stack,
  StackSeparator,
  Text,
} from '@chakra-ui/react'
import { useTranslations } from 'next-intl'
import React, { useState } from 'react'
import { useSelector } from 'react-redux'

const Language = () => {
  const router = useRouter()
  const currentLocale = useCustomLocale()
  const pathname = usePathname()
  const t = useTranslations()
  const settings = useSelector((state: IRedux) => state.settings)

  const [isOpen, setIsOpen] = useState(false)
  const [value, setValue] = useState<string>(currentLocale)

  const websiteLanguages = settings?.data?.data?.web_site_languages || []
  const filteredOptions = getFilteredLanguages(websiteLanguages)

  const onChange = (value: string) => {
    if (filteredOptions.some((lang) => lang.value === value)) {
      setValue(value)
      router.push(pathname, { locale: value })
    }
  }
  return (
    <>
      <DetailButton
        label={t('language')}
        leftIcon={<GlobeIcon color='#ED3237' />}
        onClick={() => setIsOpen(true)}
      />

      <BottomSheet contentHeight='content' isOpen={isOpen} onClose={() => setIsOpen(false)}>
        <Text color={'text'} px={4} fontSize={24} fontWeight={700}>
          {t('select_language')}
        </Text>
        <RadioCardRoot
          pb={20}
          unstyled
          value={value}
          onValueChange={(e: any) => onChange(e.value)}
        >
          <Stack
            my={4}
            separator={<StackSeparator />}
            w='full'
            flexDir='column'
          >
            {filteredOptions.map((el) => (
              <HStack
                key={el.id}
                w='full'
                flexDir='row-reverse'
                justifyContent='space-between'
                onClick={() => onChange(el.value)}
                fontSize='sm'
                px={4}
              >
                <RadioCardItem
                  py={3}
                  px={0}
                  icon={
                    value === el.value ? (
                      <CheckboxIcon color={'var(--primary-default)'} />
                    ) : (
                      <Box bg='text.muted' w={7} h={7} rounded='full' />
                    )
                  }
                  value={el.value}
                  id={el.id}
                  indicator={false}
                  border='none'
                />
                <Flex gap={4} align='center' color={'text'}>
                  {el.icon}
                  <label htmlFor={el.id}>{el.label}</label>
                </Flex>
              </HStack>
            ))}
          </Stack>
        </RadioCardRoot>
      </BottomSheet>
    </>
  )
}

export default Language
